import { jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

const gapClasses = {
    sm: 'gap-2',
    md: 'gap-4',
    lg: 'gap-6',
    xl: 'gap-8',
};
const alignClasses = {
    start: 'items-start',
    center: 'items-center',
    end: 'items-end',
};
const justifyClasses = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
    between: 'justify-between',
    around: 'justify-around',
};
/**
 * Generic container that arranges children inline with flexible spacing and alignment
 *
 * Usage:
 * <InlineContainer>
 *   <Header>...</Header>
 *   <PageActions>...</PageActions>
 * </InlineContainer>
 *
 * <InlineContainer justify="between" align="center">
 *   <SectionHeader>...</SectionHeader>
 *   <Badge>Status</Badge>
 *   <Button>Action</Button>
 * </InlineContainer>
 */
const InlineContainer = ({ children, className, align = 'start', justify = 'between', gap = 'lg', }) => {
    return (jsx("div", { className: cn('flex flex-col lg:flex-row', alignClasses[align], justifyClasses[justify], gapClasses[gap], className), children: children }));
};

export { InlineContainer };
//# sourceMappingURL=InlineContainer.js.map
